import type { ReactElement, ReactNode } from "react";
import type { UseGridFileExportReturn } from "~/hooks/useGridFileExport";

import GridExportFormatMenu from "~/components/grid/export/GridExportFormatMenu";
import GridExportProgressDialog from "~/components/grid/export/GridExportProgressDialog";
import GridFileExportContext from "~/providers/GridFileExportContext";

interface GridFileExportProviderProps {
	children: ReactNode;
	formatMenuExtraItems?: ReactElement[];
	value: UseGridFileExportReturn;
}

const GridFileExportProvider = ({ children, formatMenuExtraItems, value }: GridFileExportProviderProps) => (
	<GridFileExportContext.Provider value={value}>
		{children}
		<GridExportFormatMenu
			anchorEl={value.formatMenuAnchor}
			extraItems={formatMenuExtraItems}
			onClose={value.closeFormatMenu}
			onSelect={(format) => void value.exportAs(format)}
			open={value.formatMenuAnchor !== null}
		/>
		{value.isExporting && (
			<GridExportProgressDialog
				current={value.current}
				format={value.format}
				onCancel={value.cancel}
				open
				total={value.total}
			/>
		)}
	</GridFileExportContext.Provider>
);

export default GridFileExportProvider;
